import { useDispatch } from "react-redux";
import { ICart } from "../../../models";
import { sendCart2SPApi } from "./api/sendCart2SPApi";

export const useSP = () => {
  const dispatch = useDispatch();

  // Resolves once the server has answered, so the caller can reload the order list.
  const sendOrder = (cart: ICart) => sendCart2SPApi(dispatch, cart);

  return {
    sendOrder,
  };
};
